/* Sakina Jewelry: Build Your Set. Tiers must match the automatic discounts (2 = 20%, 3 = 25%, 4+ = 30%). */
(() => {
  const root = document.querySelector('[data-ml-bb]');
  if (!root) return;

  const TIERS = [[4, 30], [3, 25], [2, 20]];
  const tierFor = (n) => (TIERS.find(([min]) => n >= min) || [0, 0])[1];
  const moneyFormat = root.dataset.money || '${{amount}}';
  const money = (cents) => {
    const v = (Number(cents) || 0) / 100;
    const fmt = (dec, th, dp) => { const p = v.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(dp); };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (k === 'amount_with_comma_separator' ? fmt(2, '.', ',')
      : k === 'amount_no_decimals' ? fmt(0, ',', '.') : fmt(2, ',', '.')));
  };

  // set = [{ key, variantId, title, optionsLabel, price, compare, custom }]
  const set = [];
  const cards = [...root.querySelectorAll('.ml-bb__card')];

  const cardVariant = (card) => {
    const variants = JSON.parse(card.querySelector('[data-variants]').textContent);
    const chosen = [...card.querySelectorAll('select[data-option]')].map((s) => s.value);
    return variants.find((v) => chosen.every((val, i) => v.options[i] === val)) || variants[0];
  };

  const render = () => {
    const n = set.length;
    const pct = tierFor(n);
    const total = set.reduce((a, i) => a + i.price, 0);
    const was = set.reduce((a, i) => a + Math.max(i.compare, i.price), 0);
    const final = Math.round(total * (100 - pct) / 100);

    const status = root.querySelector('[data-bb-status]');
    if (n === 0) status.innerHTML = 'Choose your pieces to start your set';
    else if (n === 1) status.innerHTML = 'Add <strong>1 more piece</strong> to unlock <em>20% off</em>';
    else if (n === 2) status.innerHTML = '<strong>20% off unlocked.</strong> 1 more for <em>25% off</em>';
    else if (n === 3) status.innerHTML = '<strong>25% off unlocked.</strong> 1 more for <em>30% off</em>';
    else status.innerHTML = `<strong>${n} pieces, 30% off unlocked</strong> on your whole set`;
    root.querySelector('[data-bb-fill]').style.width = `${Math.min(n, 4) * 25}%`;
    root.querySelector('[data-bb-total]').textContent = money(final);
    root.querySelector('[data-bb-was]').textContent = was > final ? money(was) : '';
    root.querySelector('[data-bb-submit]').disabled = n === 0;
    root.querySelector('[data-bb-submit]').textContent = n ? `Add set of ${n} to bag` : 'Add set to bag';

    cards.forEach((card) => {
      const count = set.filter((i) => i.productId === card.dataset.product).length;
      card.querySelector('[data-bb-count]').textContent = count;
      card.querySelector('.ml-bb__qty').hidden = count === 0;
      card.querySelector('[data-bb-add]').hidden = count > 0;
      card.querySelector('.ml-bb__in-set').hidden = count === 0;
      card.classList.toggle('is-in', count > 0);
    });

    // one name field per personalised piece
    const customs = set.filter((i) => i.custom);
    const panel = root.querySelector('[data-bb-names]');
    const list = root.querySelector('[data-bb-names-list]');
    const previous = Object.fromEntries([...list.querySelectorAll('input')].map((el) => [el.dataset.key, el.value]));
    panel.hidden = customs.length === 0;
    list.innerHTML = customs.map((item, i) => `
      <label class="ml-bb__name">
        <span>${i + 1}. ${item.title}${item.optionsLabel ? ` <small>(${item.optionsLabel})</small>` : ''}</span>
        <input type="text" maxlength="40" placeholder="e.g. Layla" data-key="${item.key}" value="${(previous[item.key] || '').replace(/"/g, '&quot;')}">
      </label>`).join('');
  };

  const addOne = (card) => {
    const v = cardVariant(card);
    if (!v || !v.available) return;
    set.push({
      key: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      productId: card.dataset.product,
      variantId: v.id,
      title: card.querySelector('.ml-bb__card-title').textContent.trim(),
      optionsLabel: v.options.filter((o) => o !== 'Default Title').join(' / '),
      price: v.price,
      compare: v.compare,
      custom: card.dataset.custom === '1',
    });
    render();
  };

  const removeOne = (card) => {
    for (let i = set.length - 1; i >= 0; i--) {
      if (set[i].productId === card.dataset.product) { set.splice(i, 1); break; }
    }
    render();
  };

  root.addEventListener('click', (event) => {
    const card = event.target.closest('.ml-bb__card');
    if (event.target.closest('[data-bb-add]') && card) addOne(card);
    const step = event.target.closest('[data-bb-step]');
    if (step && card) (Number(step.dataset.bbStep) > 0 ? addOne : removeOne)(card);
  });

  root.addEventListener('change', (event) => {
    const select = event.target.closest('select[data-option]');
    if (!select) return;
    const card = select.closest('.ml-bb__card');
    const v = cardVariant(card);
    card.querySelector('[data-price]').textContent = money(v.price);
    card.querySelector('[data-compare]').textContent = v.compare > v.price ? money(v.compare) : '';
    const img = card.querySelector('.ml-bb__card-media img');
    if (img && v.image) {
      img.removeAttribute('srcset');
      img.src = v.image;
    }
    card.classList.add('is-switched');
    setTimeout(() => card.classList.remove('is-switched'), 250);
  });

  root.querySelector('[data-bb-submit]').addEventListener('click', async (event) => {
    const button = event.currentTarget;
    const err = root.querySelector('[data-bb-err]');
    const names = Object.fromEntries([...root.querySelectorAll('[data-bb-names-list] input')].map((el) => [el.dataset.key, el.value.trim()]));
    const missing = set.some((i) => i.custom && !names[i.key]);
    err.hidden = !missing;
    if (missing) {
      root.querySelector('[data-bb-names]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // merge identical non personalised pieces, keep each personalised piece on its own line
    const items = [];
    set.forEach((i) => {
      if (i.custom) { items.push({ id: i.variantId, quantity: 1, properties: { Name: names[i.key] } }); return; }
      const same = items.find((x) => x.id === i.variantId && !x.properties);
      if (same) same.quantity += 1; else items.push({ id: i.variantId, quantity: 1 });
    });

    button.disabled = true;
    button.textContent = 'Adding your set';
    try {
      const res = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error('add failed');
      set.length = 0;
      render();
      if (window.mlRefreshCart) await window.mlRefreshCart();
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.show === 'function') drawer.show();
    } catch (e) {
      button.textContent = 'Something went wrong, try again';
    } finally {
      button.disabled = set.length === 0;
    }
  });

  render();
})();
